export const tryParse = <T>(stringified: string) => {
  try {
    // try to unstringify a found value
    return JSON.parse(stringified || '') as T;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e: unknown) {
    return stringified as T | undefined;
  }
};
export const isObject = (val: unknown) => !!val && typeof val === 'object';
